module.exports = __webpack_public_path__ + "img/product_104.05ecf44.webp";